import { fetchCachedPublicGet } from "./publicRequest";

const buildQuery = (params = {}) => {
  const search = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
  const query = search.toString();
  return query ? `?${query}` : "";
};

export const fetchExperienceCategories = (params = {}, options = {}) =>
  fetchCachedPublicGet(`/explore/experience-categories${buildQuery(params)}`, options);

export const extractExperienceCategoryRows = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  return [];
};

export default {
  fetchExperienceCategories,
  extractExperienceCategoryRows,
};
